import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const PageHeader = styled.div`
  padding: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;

export const PageTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const ContentContainer = styled.div`
  flex: 1;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`; 